export default __webpack_public_path__ + "static/media/arbitiumLogo_textOnly.0c864111.svg";